import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { displayFolderName } from './display';

/**
 * Mostra le cartelle archivio giornaliere (AAAA-MM-GG) come data estesa,
 * es. "2026-10-23" -> "23 ottobre 2026". Solo visualizzazione: il nome su disco non cambia.
 */
@Pipe({
  name: 'nxeFolderName',
  standalone: true,
})
export class FolderNamePipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(name: string | null | undefined): string {
    return displayFolderName(name || '', this.translate.currentLang || this.translate.defaultLang);
  }
}
